<template>
  <div :class="{ 'quote-orm-licence-expired': $licenceExpired }">
    <div>
      <div>
        <article class="box">
          <div class="columns">
            <div class="column">
              <p class="title">ORM</p>
            </div>
            <div class="column is-narrow">
              <div v-if="value.orm"
                class="dropdown is-right is-hoverable">
                <div class="dropdown-trigger">
                  <button class="button"
                    aria-haspopup="true"
                    aria-controls="dropdown-menu-pnet">
                    <span>ORM</span>
                    <span class="icon is-small">
                      <i class="mdi mdi-chevron-down"
                        aria-hidden="true" />
                    </span>
                  </button>
                </div>

                <div class="dropdown-menu"
                  id="dropdown-menu-pnet"
                  role="menu">
                  <div class="dropdown-content">
                    <a v-if="isActionEnabled && ormUnreadMessageCount == 0 && value.orm.canSubmit"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      :class="{ 'is-licence-disabled': $licenceExpired }"
                      @click="!$licenceExpired && sendQuote(ormSendQuoteTypes.Quote)">
                      <span class="icon is-small is-left has-text-primary">
                        <i class="mdi mdi-upload mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Submit Quote</span>
                    </a>
                    <a v-if="isSubmitTaxInvoiceEnabled"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      :class="{ 'is-disabled': !$licenceExpired && (cannotRaiseInvoice || hasDiffInvoicedAndAuthorised), 'is-licence-disabled': $licenceExpired }"
                      @click.prevent="!$licenceExpired && (!cannotRaiseInvoice && !hasDiffInvoicedAndAuthorised) && sendInvoice(false)">
                      <span class="icon is-small is-left has-text-primary">
                        <i class="mdi mdi-currency-usd mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Submit Tax Invoice</span>
                    </a>
                    <a v-if="isActionEnabled"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      :class="{ 'is-licence-disabled': $licenceExpired }"
                      @click="!$licenceExpired && declineQuoteRequest()">
                      <span class="icon is-small is-left has-text-primary">
                        <i class="mdi mdi-cancel mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Decline Quote Request</span>
                    </a>
                    <a v-if="isActionEnabled"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      :class="{ 'is-licence-disabled': $licenceExpired }"
                      @click="!$licenceExpired && sendQuote(ormSendQuoteTypes.TotalLoss)">
                      <span class="icon is-small is-left has-text-primary">
                        <i class="mdi mdi-car-off mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Inform Total Loss</span>
                    </a>
                    <a v-if="isActionEnabled"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      :class="{ 'is-licence-disabled': $licenceExpired }"
                      @click="!$licenceExpired && sendQuote(ormSendQuoteTypes.RequestInspection)">
                      <span class="icon is-small is-left has-text-primary">
                        <i class="mdi mdi-eye-check-outline mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Request Inspection</span>
                    </a>
                    <a v-if="isSubmitTaxInvoiceEnabled"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      :class="{ 'is-disabled': !$licenceExpired && !cannotRaiseInvoice, 'is-licence-disabled': $licenceExpired }"
                      @click.prevent="!$licenceExpired && !cannotRaiseInvoice && sendInvoice(true)">
                      <span class="icon is-small is-left has-text-primary">
                        <i class="mdi mdi-restart mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Re-activate Tax Invoice</span>
                    </a>
                    <hr class="dropdown-divider">
                    <a v-if="$user.info.isSupportUser"
                      href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      @click="showUtilities()">
                      <span class="icon is-small is-left has-text-primary"
                        style="self-align: center">
                        <i class="mdi mdi-tools mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">Utilities</span>
                    </a>
                    <a href="#"
                      class="dropdown-item dropdown-item-has-icon"
                      @click="viewMessages('ORM')">
                      <span class="icon is-small is-left has-text-primary"
                        style="self-align: center">
                        <i class="mdi mdi-file-code mdi-18px" />
                      </span>
                      <span class="dropdown-item-text">View Messages</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="columns">
            <div class="column is-narrow">
              <table class="table is-bordered is-striped">
                <tr>
                  <td class="has-text-weight-bold has-vertical-middle">Unread Messages</td>
                  <td>
                    <div class="is-flex is-align-items-center is-justify-content-space-between">
                      <span>
                        {{ ormUnreadMessageCount }} Unread
                      </span>

                      <div class="button is-primary"
                        @click="handleViewOrmUnreadMessages">
                        View
                      </div>

                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold has-vertical-middle">Message No.</td>
                  <td v-if="$user.info.isSupportUser">
                    <the-mask class="input"
                      placeholder="Message No."
                      v-model="innerValue.orm.messageNo"
                      :disabled="$licenceExpired"
                      :mask="['##']" />
                  </td>
                  <td v-else>{{ value.orm.messageNo }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold has-vertical-middle">ReInstatement No.</td>
                  <td v-if="$user.info.isSupportUser">
                    <the-mask class="input"
                      type="number"
                      placeholder="ReInstatement No."
                      v-model="innerValue.orm.reinstatementNo"
                      :disabled="$licenceExpired"
                      :mask="['##']" />
                  </td>
                  <td v-else>{{ value.orm.reinstatementNo }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold has-vertical-middle">Quote Status</td>
                  <td v-if="$user.info.isSupportUser">
                    <div class="select">
                      <select v-model="innerValue.orm.quoteStatusId"
                        :disabled="$licenceExpired">
                        <option v-for="type in quoteStatusTypes"
                          :key="type.value"
                          :value="type.value">{{ type.name }}</option>
                      </select>
                    </div>
                  </td>
                  <td v-else>{{ quoteStatusTypes?.find(s => s.value === value.orm.quoteStatusId)?.name }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold">Vehicle ID</td>
                  <td v-if="$user.info.isSupportUser">
                    <input class="input is-capitalized"
                      type="text"
                      placeholder="Vehicle ID"
                      v-model="innerValue.orm.vehicleId"
                      :disabled="$licenceExpired"
                      maxlength="20">
                  </td>
                  <td v-else>{{ value.orm.vehicleId }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold">Underwriter</td>
                  <td v-if="$user.info.isSupportUser">
                    <input class="input is-capitalized"
                      type="text"
                      placeholder="Underwriter"
                      v-model="innerValue.orm.underwriter"
                      :disabled="$licenceExpired"
                      maxlength="45">
                  </td>
                  <td v-else>{{ value.orm.underwriter }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold">Make &amp; Model</td>
                  <td>{{ value.orm.make }} {{ value.orm.model }} {{ value.orm.series }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold">Quote Type</td>
                  <td>{{ value.orm.quoteType }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold">Damaged Areas</td>
                  <td>{{ value.orm.damagedAreas }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold">QDE Status</td>
                  <td>{{ $filters.formatQdeStatus(value.orm.qdeStatus) }}</td>
                </tr>
                <tr>
                  <td class="has-text-weight-bold has-vertical-middle">Batch Number</td>
                  <td v-if="ormQuoteBatch">
                    <div class="is-flex is-align-items-center is-justify-content-space-between">
                      <span>{{ ormQuoteBatch.batchNo }}</span>
                      <button class="button is-primary"
                        @click="viewOrmBatchDetail">
                        View
                      </button>
                    </div>
                  </td>
                  <td v-else>N/A</td>
                </tr>
              </table>
            </div>

            <!-- <div class="column ">
              <div v-if="ormUnreadMessageCount > 0 || !value.orm.canSubmit"
                class="unread-messages-section">
                <div class="is-flex">
                  <span class="material-symbols-outlined has-text-warning mr-2">
                    warning
                  </span>
                  <span>
                    Note: The submit Quote button is currently disabled because there are unread messages for this quote. Please view and load messages to unlock the submit function.
                  </span>
                </div>
              </div>
            </div> -->
            <div class="column is-5">
              <div v-if="ormUnreadMessageCount > 0 || !value.orm.canSubmit || IsOrmPaymentUnableLoad"
                class="unread-messages-section mb-4">
                <div class="is-flex flex-start">
                  <span class="material-symbols-outlined has-text-warning mr-2">
                    warning
                  </span>
                  <div>
                    <p class="mb-3"
                      v-if="IsOrmPaymentUnableLoad">
                      Note: The latest Payment Authorisation message for this quote was <b>NOT</b>  loaded successfully because the message number is out of sequence. The expected message number is <b>{{ormExpectedMessageNo }}</b>, but the received message is <b>{{ormLatestPaymentAuthorisedMessage.ormMessageNo }}</b>. Please load the message manually.
                    </p>
                    <p class="mb-3"
                      v-if="!value.orm.canSubmit">
                      Note: The Submit Quote button is currently disabled because a Payment Authorisation Message has been received for this job.
                    </p>
                    <p class="mb-3"
                      v-if="ormUnreadMessageCount > 0">
                      Note: The submit Quote button is currently disabled because there are unread messages for this quote. Please view and load messages to unlock the submit function.
                    </p>
                    <div v-if="!value.orm.canSubmit">
                      <p class="mb-3">
                        Please review the information below and send an email to the appropriate
                        department via the <strong>Communications</strong> tab.
                      </p>
                      <p class="mb-3"><strong>Quote Variation</strong><br>
                        If submitting a quote variation, email nationalassessing@iag.com.au
                        <a href="mailto:nationalassessing@iag.com.au"
                          class="icon has-text-primary">
                          <i class="mdi mdi-link-box-variant mdi-24px" />
                        </a>
                      </p>
                      <p class="mb-3"><strong>Invoice Variation</strong><br>
                        If submitting an invoice variation, email supplierinvoices@iag.com.au
                        <a href="mailto:supplierinvoices@iag.com.au"
                          class="icon has-text-primary">
                          <i class="mdi mdi-link-box-variant mdi-24px" />
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <article v-if="hasDiffInvoicedAndAuthorised"
                class="message"
                :class="'is-warning ' + ($theme.isDark ? 'is-dark' : 'is-light')">
                <header class="message-header">
                  <span class="is-flex is-align-items-center">
                    <span class="msr msr-24px mr-2 has-text-amber">warning</span>
                    <span>Authorised Amount Mismatch</span>
                  </span>
                </header>

                <section class="message-body"
                  :class="$theme.isDark ? 'is-dark' : 'is-light'">
                  <p class="mb-3">
                    The authorised amount for this invoice doesn't match the invoiced amount.<br />
                    To continue,
                    <span>please update the invoice so that the totals align before proceeding.</span>
                  </p>
                  <div class="table-container mb-4">
                    <table class="table is-fullwidth">
                      <thead>
                        <tr>
                          <th>Quote</th>
                          <th class="has-text-right">Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="row in invoiceRows"
                          :key="row.quoteId">
                          <td>{{ row.label }}</td>
                          <td class="has-text-right">{{ $filters.formatCurrency(row.total, $userInfo.locale, false, 2) }}</td>
                        </tr>
                        <tr class="has-text-weight-bold tr-top-border-2px">
                          <td>Totals</td>
                          <td class="has-text-right">{{ $filters.formatCurrency(totalQuotesAmount, $userInfo.locale, false, 2) }}</td>
                        </tr>
                        <tr class="has-text-weight-semibold tr-top-border-2px authorised-row">
                          <td class="">Authorised Amount in ORM</td>
                          <td class="has-text-right">{{ $filters.formatCurrency(totalAuthorisedAmount, $userInfo.locale, false, 2) }}</td>
                        </tr>
                        <tr class="has-text-weight-semibold">
                          <td>Amount (Ext GST) In Invoice</td>
                          <td class="has-text-right">{{ $filters.formatCurrency(totalInvoicedAmount, $userInfo.locale, false, 2) }}</td>
                        </tr>
                        <tr class="has-text-weight-bold difference-row">
                          <td>Difference</td>
                          <td class="has-text-right has-text-danger has-text-weight-bold">{{ $filters.formatCurrency(amountDifference, $userInfo.locale, false, 2) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </section>
              </article>
              <div v-else-if="cannotRaiseInvoice">
                <div class="bulma-message-modal">
                  <article class="message bulma-message-modal-panel"
                    :class="'is-warning ' + ($theme.isDark ? 'is-dark' : 'is-light')">
                    <header class="message-header">
                      <span class="is-flex is-align-items-center">
                        <span class="msr msr-24px mr-2 has-text-amber">warning</span>
                        <span>Invoice Pending Payment Authority</span>
                      </span>
                    </header>
                    <section class="message-body"
                      :class="$theme.isDark ? 'is-dark' : 'is-light'">
                      <p class="mb-3">
                        An invoice has already been submitted for this quote and is awaiting payment authority.<br />
                        Raising a new invoice is currently disabled.
                      </p>
                    </section>
                  </article>
                </div>
              </div>
            </div>

            <!-- <div class="column">
              <div class="field has-checkradio">
                <div class="control">
                  <input class="is-checkradio is-primary"
                    :class="{ 'has-background-color': innerValue.orm.outOfScope }"
                    id="oufofscope"
                    type="checkbox"
                    name="oufofscope"
                    v-model="innerValue.orm.outOfScope">
                  <label for="oufofscope">Out Of Scope</label>
                </div>
              </div>
            </div> -->
          </div>
        </article>
        <article class="box">
          <p class="title">Remarks</p>
          <bulma-table class="table is-bordered is-striped is-narrow is-fullwidth"
            :columns="columns"
            :page-index="filter.pageIndex"
            :page-size="filter.pageSize"
            :total-rows="remarkTotalRows"
            :is-loading="isTableLoading"
            :sort-column="filter.sortColumn"
            :sort-order="filter.sortOrder"
            :show-header="false"
            @pageChanged="onPageChange"
            @sort="sort">
            <tr v-for="(remark, index) in pagedRemarks"
              :key="remark.remarkId"
              @click="highlightSelected(index, $event)">
              <td class="is-content-width">
                <span class="tag is-info">{{ $filters.formatDateTimeLocale(remark.remarkDateTime, $userInfo.locale) }}</span>
              </td>
              <td class="is-remark">
                <div>{{ remark.remarks }}</div>
              </td>
            </tr>
            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <span icon="icon is-large">
                    <i class="mdi mdi-48px mdi-emoticon-sad" />
                  </span>
                  <p>Nothing</p>
                </div>
              </section>
            </template>
          </bulma-table>
        </article>
      </div>
    </div>
    <xml-viewer-modal v-if="isXmlViewerModalActive"
      :active.sync="isXmlViewerModalActive"
      :quote-id="value.quoteId"
      :message-type="messageType"
      :page-size="10"
      @close="isXmlViewerModalActive = false">
      <p slot="text-title">View {{ messageType }} Messages</p>
    </xml-viewer-modal>
    <orm-decline-quote-request-modal v-if="isOrmDeclineQuoteRequestModalActive"
      :active.sync="isOrmDeclineQuoteRequestModalActive"
      :value="value"
      @close="isOrmDeclineQuoteRequestModalActive = false" />
    <orm-send-quote-modal v-if="isOrmSendQuoteModalActive"
      :active.sync="isOrmSendQuoteModalActive"
      :value="value"
      :send-quote-type="sendQuoteType"
      @close="isOrmSendQuoteModalActive = false" />
    <orm-submit-tax-invoice-modal v-if="isOrmSubmitTaxInvoiceModalActive"
      :active.sync="isOrmSubmitTaxInvoiceModalActive"
      :is-reactivate-invoice="isReactivateInvoice"
      :value="value"
      @sent="reload()" />
    <confirm-modal v-if="isConfirmModalActive"
      :active.sync="isConfirmModalActive"
      @ok="sendQuote(ormSendQuoteTypes.Quote, true)"
      @cancel="isConfirmModalActive = false"
      ok-text="Proceed"
      cancel-text="Cancel">
      <p slot="text-title">Submit Quote</p>
      <p slot="text-content">
        <span class="has-text-weight-bold">
          AUTHORISATION FOR LAST QUOTE NOT YET RECEIVED FROM INSURER. WE STRONGLY RECCOMMEND THAT YOU WAIT FOR THE AUTHORISATION MESSAGE AND LOAD IT INTO THIS QUOTE BEFORE YOU SEND MORE VARIATIONS
        </span>
      </p>
    </confirm-modal>
    <confirm-modal v-if="isWarningModalActive"
      :active.sync="isWarningModalActive"
      @ok="showSubmitTaxInvoiceModal(true)"
      @cancel="isWarningModalActive = false"
      :ok-text="'Yes'"
      :cancel-text="'No'">
      <p slot="text-title">Send Invoice</p>
      <p slot="text-content">
        <span class="has-text-primary has-text-weight-bold"> Some items haven't been authorised. Do you want to proceed? Please note, only the authorised amounts will be sent to the insurer.
        </span>
      </p>
    </confirm-modal>
    <orm-pnet-utilities-modal v-if="isOrmUtilitiesModalActive"
      v-model="innerValue"
      :active.sync="isOrmUtilitiesModalActive" />
  </div>
</template>

<script>
import { QdeStatusTypes, InvoiceTypes, OrmSendQuoteTypes, OrmQuoteStatusTypes, RemarkTypes, EventHubTypes, MessageStatusTypes, QuotingMethodTypes } from '@/enums'
import { XmlViewerModal } from '@/components/XmlViewer'
import { QuoteNotificationMixin, QuoteAssessmentMixin } from './mixins'
import { OrmDeclineQuoteRequestModal, OrmSendQuoteModal, OrmSubmitTaxInvoiceModal } from './components'
import QuoteStoreMixin from './mixins/QuoteStoreMixin'
import { ConfirmModal } from '@/components/BulmaModal'
import { RemarkColumns } from './columns'
import BulmaTable from '@/components/BulmaTable'
import { DateTimeFiltersMixin } from '@/components/mixins/filters'
import _cloneDeep from 'lodash/cloneDeep'
import { OrmService } from '@/services'
import OrmPnetUtilitiesModal from './components/OrmPnetUtilitiesModal'
import { TheMask, mask } from 'vue-the-mask'
import OrmMessageService from '../ormmessage/OrmMessageService'
import { Columns } from '../ormmessage/columns'
import StoreMixin from './storeMixin'
import OrmBatchingService from '../ormbatching/OrmBatchingService'
import QuoteService from './QuoteService'
import QuoteInvoiceStoreMixin from './mixins/QuoteInvoiceStoreMixin'
import { roundAwayFromZero } from '@/components/utils/AccountingFunctions'
import { MessageTypes } from '@/enums'

export default {
  name: 'QuoteOrm',
  inject: ['$vv'],
  directives: { mask },
  components: {
    XmlViewerModal,
    OrmDeclineQuoteRequestModal,
    OrmSendQuoteModal,
    ConfirmModal,
    BulmaTable,
    OrmSubmitTaxInvoiceModal,
    OrmPnetUtilitiesModal,
    TheMask
  },
  mixins: [QuoteNotificationMixin, StoreMixin, QuoteStoreMixin, DateTimeFiltersMixin, QuoteAssessmentMixin, QuoteInvoiceStoreMixin],
  props: {
    value: null,
    ormUnreadMessageCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      innerValue: null,
      messageType: 'ORM',
      isXmlViewerModalActive: false,
      isOrmDeclineQuoteRequestModalActive: false,
      isOrmSendQuoteModalActive: false,
      sendQuoteType: OrmSendQuoteTypes.Quote,
      isConfirmModalActive: false,
      isWarningModalActive: false,
      isSendQuoteAnyway: false,
      isOrmSubmitTaxInvoiceModalActive: false,
      filter: {
        sortColumn: RemarkColumns[0].name,
        sortOrder: RemarkColumns[0].defaultOrder,
        pageIndex: 1,
        pageSize: 8
      },
      isTableLoading: false,
      isReactivateInvoice: false,
      quoteStatusTypes: null,
      isOrmUtilitiesModalActive: false,
      ormQuoteBatch: null,
      quotesTotals: [],
      innerInvoice: null,
      ormLatestPaymentAuthorisedMessage: null
    }
  },
  computed: {
    $v() {
      return this.$vv || this.$v
    },
    qdeStatusTypes() {
      return QdeStatusTypes
    },
    isActionEnabled() {
      return this.value.orm && this.value.orm.messageNo
    },
    isSubmitTaxInvoiceEnabled() {
      return this.value.invoices.some((i) => i.invoiceType === InvoiceTypes.Quote && !i.deleted)
    },
    ormSendQuoteTypes() {
      return OrmSendQuoteTypes
    },
    columns() {
      return RemarkColumns
    },
    remarkTotalRows() {
      return this.value.otherRemarks.filter((r) => r.remarkTypeId === RemarkTypes.ORMSystemRemark && !r.isDeleted).length
    },
    activeRemarks() {
      return this.value.otherRemarks.filter((r) => r.remarkTypeId === RemarkTypes.ORMSystemRemark && !r.isDeleted)
    },
    pagedRemarks() {
      return this.activeRemarks.slice((this.filter.pageIndex - 1) * this.filter.pageSize, this.filter.pageIndex * this.filter.pageSize)
    },
    MessageStatusTypes() {
      return MessageStatusTypes
    },
    filterKey() {
      if (this.$userInfo) {
        return `${this.$userInfo.sessionId}|ormmessage|filter`
      } else {
        return ''
      }
    },
    Columns() {
      return Columns
    },
    isOrmInvoiceSubmitted() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.QuoteInvoiceSubmitted
    },
    isOrmReactiveInvoiceSubmitted() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.ReactiveInvoiceSubmitted
    },
    isOrmAdjustmentNoteSubmitted() {
      return this.innerValue && this.innerValue.orm && this.innerValue.orm.quoteStatusId === OrmQuoteStatusTypes.AdjustmentNoteSubmitted
    },
    cannotRaiseInvoice() {
      return this.isOrmInvoiceSubmitted || this.isOrmReactiveInvoiceSubmitted || this.isOrmAdjustmentNoteSubmitted
    },
    hasInvoices() {
      return this.value?.invoices?.some((inv) => !inv.deleted && inv.includedQuotes?.length > 0)
    },
    invoiceRows() {
      if (!this.quotesTotals || this.quotesTotals.length === 0) {
        return []
      }

      return this.quotesTotals
        .map((quote) => {
          let label = 'Unknown'
          if (quote.subQuoteNo === 0) {
            label = 'Main'
          } else if (quote.subQuoteNo > 0) {
            label = `Supp-${quote.subQuoteNo}`
          }

          const totalExGst = quote.totalExGst || 0
          // const excess = quote.excess || 0
          // const ownerContribution = quote.ownerContribution || 0
          const total = totalExGst

          return {
            quoteId: quote.quoteId,
            subQuoteNo: quote.subQuoteNo,
            label,
            totalExGst,
            total
          }
        })
        .sort((a, b) => a.subQuoteNo - b.subQuoteNo)
    },
    totalQuotesAmount() {
      if (!this.quotesTotals || this.quotesTotals.length === 0) {
        return 0
      }
      return this.quotesTotals.reduce((sum, quote) => sum + (quote.totalExGst || 0), 0)
    },
    totalAuthorisedAmount() {
      if (!this.quotesTotals || this.quotesTotals.length === 0) {
        return 0
      }
      return this.quotesTotals.reduce((sum, quote) => sum + (quote.authorisedAmount || 0), 0)
    },
    totalInvoicedAmount() {
      const invoiceTotalExGst =
        (this.innerInvoice.partTotal || 0) + (this.innerInvoice.labourTotal || 0) + (this.innerInvoice.miscTotal || 0) + (this.innerInvoice.subletTotal || 0) + (!this.isAssessmentEnabled ? (this.innerInvoice.mechTotal || 0) : 0)
      return roundAwayFromZero(invoiceTotalExGst)
    },
    amountDifference() {
      return this.totalAuthorisedAmount - this.totalInvoicedAmount
    },
    hasDiffInvoicedAndAuthorised() {
      if (!this.innerValue.authorisedAmount) return false //skip if authorised amount is not set
      //if (this.innerValue?.isAssessmentEnabled) return false
      if (this.innerValue?.orm?.quoteStatusId === OrmQuoteStatusTypes.PaymentAuthorised) return false
      if (!this.isSubmitTaxInvoiceEnabled) return false
      if (!this.totalAuthorisedAmount || !this.totalInvoicedAmount) return false

      const roundingTolerance = 0.05 // Allow 5 cents difference (rounding tolerance)

      if (this.isAssessmentEnabled) {
        return Math.abs(this.totalInvoicedAmount - this.totalAuthorisedAmount) > roundingTolerance
      } else {
        const diff1 = Math.abs(this.totalInvoicedAmount - this.totalAuthorisedAmount) > roundingTolerance
        const diff2 = Math.abs(this.totalInvoicedAmount - this.totalQuotesAmount) > roundingTolerance
        return diff1 || diff2
      }
    },
    isAssessmentEnabled() {
      return this.innerValue?.isAssessmentEnabled
    },
    IsOrmPaymentUnableLoad() {
      if (this.innerValue && this.innerValue.orm && this.ormLatestPaymentAuthorisedMessage) {
        const currentMessageNo = parseInt(this.innerValue.orm.messageNo, 10) || 0
        const expectedMessageNo = currentMessageNo + 1
        if (this.ormLatestPaymentAuthorisedMessage && expectedMessageNo !== this.ormLatestPaymentAuthorisedMessage.ormMessageNo && this.ormLatestPaymentAuthorisedMessage.statusId === 30) {
          return true
        }
      }
      return false
    },
    ormExpectedMessageNo() {
      if (this.innerValue && this.innerValue.orm) {
        return (parseInt(this.innerValue.orm.messageNo, 10) || 0) + 1
      }
      return null
    }
  },
  watch: {
    // 'innerValue.orm.outOfScope': function(newVal, oldVal) {
    //   this.$emit('input', newVal)
    // }
    innerValue: {
      handler: function (newVal, oldVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  async created() {
    this.innerValue = _cloneDeep(this.value)
    this.getOrmQuoteStatusTypes()
    this.getOrmQuoteBatch()
    this.getIncludedQuotesTotals()
    this.getInvoice()
    if (!!this.innerValue.orm) {
      await this.getOrmUnreadPaymentAuthorisedMessage()
    }
  },
  mounted() {
    this.$eventHub.$on(EventHubTypes.EntitySaved, () => {
      this.innerValue = _cloneDeep(this.value)
      this.reloadInvoice()
    })
  },
  beforeDestroy() {
    this.$eventHub.$off(EventHubTypes.EntitySaved)
  },
  methods: {
    reloadInvoice() {
      this.getIncludedQuotesTotals()
      this.getInvoice()
    },
    updateInvoice() {
      const entity = this.currentSnapshot
      if (entity) {
        this.innerInvoice = this.innerValue.invoices.find((i) => i.invoiceType === InvoiceTypes.Quote && !i.deleted)
        if (!this.innerInvoice) return

        console.log('this.invoiceIncludedQuotes: ', this.invoiceIncludedQuotes)

        // Calculate all invoice values
        ;(this.innerInvoice.gstRate = entity.gstRate),
          (this.innerInvoice.labourTotal = roundAwayFromZero(
            entity.labourTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.labourTotal, 0)
          )),
          (this.innerInvoice.rrTotal = roundAwayFromZero(entity.rrTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.rrTotal, 0))),
          (this.innerInvoice.repairTotal = roundAwayFromZero(
            entity.repairTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.repairTotal, 0)
          )),
          (this.innerInvoice.rwaTotals = roundAwayFromZero(entity.rwaTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.rwaTotal, 0))),
          (this.innerInvoice.paintTotal = roundAwayFromZero(
            entity.paintTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.paintTotal, 0)
          )),
          (this.innerInvoice.fgTotal = roundAwayFromZero(entity.fgTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.fgTotal, 0))),
          (this.innerInvoice.crushTotal = roundAwayFromZero(
            entity.crushTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.crushTotal, 0)
          )),
          (this.innerInvoice.cdTotal = roundAwayFromZero(entity.cdTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.cdTotal, 0))),
          (this.innerInvoice.mechTotal = roundAwayFromZero(entity.mechTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.mechTotal, 0))),
          (this.innerInvoice.opgTotal = roundAwayFromZero(entity.opgTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.opgTotal, 0))),
          (this.innerInvoice.partTotal = roundAwayFromZero(entity.partTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.partTotal, 0))),
          (this.innerInvoice.miscTotal = roundAwayFromZero(entity.miscTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.miscTotal, 0))),
          (this.innerInvoice.subletTotal = roundAwayFromZero(
            entity.sublTotal + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.sublTotal, 0)
          )),
          (this.innerInvoice.excessAmount = roundAwayFromZero(entity.excess + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.excess, 0))),
          (this.innerInvoice.ownerContribution = roundAwayFromZero(
            entity.ownersContribution + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.ownerContribution, 0)
          )),
          (this.innerInvoice.quoteDiscount = roundAwayFromZero(
            entity.discount + this.invoiceIncludedQuotes.reduce((total, quote) => total + quote.discount, 0)
          ))

        this.recalculateTotals()

        this.$emit('save')

        this.$nextTick(() => {
          this.showSuccessToast('Invoice updated to match authorised totals.<br/>Submission unlocked.')
        })
      }
    },
    recalculateTotals() {
      const includedQuotesTotalExGst = this.invoiceIncludedQuotes.reduce(function (total, quote) {
        return roundAwayFromZero(total + (quote.totalExGst || 0))
      }, 0)
      console.log('this.innerValue.totalExGst: ', this.innerValue.totalExGst)
      console.log('includedQuotesTotalExGst: ', includedQuotesTotalExGst)
      const quotesTotalExGst = roundAwayFromZero(this.innerValue.totalExGst + includedQuotesTotalExGst)
      console.log('quotesTotalExGst: ', quotesTotalExGst)

      if (!this.innerValue.excessWithGst) {
        // let ownerContributionGst = roundAwayFromZero((this.innerInvoice.ownerContribution * this.innerInvoice.gstRate) / 100)
        // this.innerInvoice.totalExGst = roundAwayFromZero(
        //   quotesTotalExGst - this.innerInvoice.quoteDiscount - this.innerInvoice.excessAmount - this.innerInvoice.ownerContribution - ownerContributionGst
        // )
        this.innerInvoice.totalExGst = roundAwayFromZero(quotesTotalExGst)
        this.innerInvoice.gst = roundAwayFromZero(((quotesTotalExGst - this.innerInvoice.quoteDiscount) * this.innerValue.gstRate) / 100)
        this.innerInvoice.totalIncGst = roundAwayFromZero(this.innerInvoice.totalExGst + this.innerInvoice.gst)
      } else {
        // this.innerInvoice.totalExGst = roundAwayFromZero(
        //   quotesTotalExGst - this.innerInvoice.excessAmount - this.innerInvoice.quoteDiscount - this.innerInvoice.ownerContribution
        // )
        this.innerInvoice.totalExGst = roundAwayFromZero(quotesTotalExGst)
        this.innerInvoice.gst = roundAwayFromZero((this.innerInvoice.totalExGst * this.innerInvoice.gstRate) / 100)
        this.innerInvoice.totalIncGst = this.innerInvoice.totalExGst + this.innerInvoice.gst
      }
      console.log('innerInvoice: ', this.innerInvoice.totalIncGst)
    },
    async getInvoice() {
      this.innerInvoice =
        this.innerValue?.invoices?.length > 0 ? this.innerValue.invoices.find((i) => i.invoiceType === InvoiceTypes.Quote && !i.deleted) : null
    },
    async getIncludedQuotesTotals() {
      const rawQuoteIds = this.innerValue.invoices
        .filter((inv) => inv.invoiceType === InvoiceTypes.Quote && !inv.deleted)
        .filter((inv) => inv.includedQuotes && inv.includedQuotes?.length > 0)
        .flatMap((inv) => inv.includedQuotes)
      const quoteIds = [...new Set(rawQuoteIds.filter(Boolean))]

      const vm = this

      let quotesTotals = await QuoteService.getIncludedQuotesTotals(quoteIds)
      this.quotesTotals.splice(0, this.quotesTotals.length, ...quotesTotals)

      console.log('quotesTotals: ', this.quotesTotals)

      this.clearInvoiceIncludedQuotes()
      this.quotesTotals.forEach(function (q) {
        if (q && q.subQuoteNo !== vm.innerValue.subQuoteNo) {
          vm.addInvoiceIncludedQuotes(_cloneDeep(q))
        }
      })

      console.log('invoiceIncludedQuotes: ', this.invoiceIncludedQuotes)
    },
    handleViewOrmUnreadMessages() {
      const filter = {
        quoteNo: '',
        rego: '',
        claimNo: this.value.claimNo,
        messageTypeId: 0,
        messageStatusId: MessageStatusTypes.UnRead,
        sortColumn: Columns[Columns.length - 2].name,
        sortOrder: Columns[Columns.length - 2].defaultOrder,
        pageIndex: 1,
        pageSize: 18,
        customerNameOrContactNo: ''
      }

      sessionStorage.setItem(this.filterKey, JSON.stringify(filter))
      sessionStorage.setItem(`${this.$userInfo.sessionId}|ormmessage|returnUrl`, this.$route.path)

      this.$router.push({ path: '/ormmessages' })
    },
    viewMessages(type) {
      this.messageType = type
      this.isXmlViewerModalActive = true
    },
    async sendQuote(type, sendAnyway = false) {
      if (this.$licenceExpired) return
      if (this.value.quotingMethod === QuotingMethodTypes.Dollar) {
        this.showToast('ORM does not accept Dollar quotes.', 'warning')
        return
      }

      this.$showSpinner()
      const hasPenndingMessage = await OrmMessageService.hasAnyPendingOrmMessage(this.innerValue.quoteId)
      await OrmMessageService.validateQuoteItems(this.innerValue.quoteId)
      this.$hideSpinner()
      if (hasPenndingMessage) {
        this.$notification.openNotificationWithType('danger', 'ORM', 'There are pending messages. Please load those messages before sending quote.')
        return
      }

      if (this.$parent && this.$parent.touchOrmHeaderValidators) {
        this.$parent.touchOrmHeaderValidators()
        this.$parent.touchOrmSummaryValidators()
      } else {
        this.touchOrmHeaderValidators()
        this.touchOrmSummaryValidators()
      }

      if (this.$parent && this.$parent.validateJobStartEndForOrm) {
        this.$parent.validateJobStartEndForOrm()
      } else {
        this.validateJobStartEndForOrm()
      }

      const hasJobDateError =
        !this.$v.entity.jobStart.bothRequired || !this.$v.entity.jobEnd.bothRequired || this.$v.entity.jobStart.$error || this.$v.entity.jobEnd.$error

      if (this.$v.ormHeaderGroup.$error || this.$v.ormSummaryGroup.$error || hasJobDateError) {
        this.$notification.openNotificationWithType('danger', 'ORM', 'Send cancelled. Required fields are missing or invalid')
        return
      }

      if (this.$parent && this.$parent.resetOrmValidation) {
        this.$parent.resetOrmValidation()
      } else {
        this.resetOrmValidation()
      }

      await this.saveAndContinue(async () => {
        if (this.value.orm.quoteStatusId === OrmQuoteStatusTypes.QuoteSubmitted && type === OrmSendQuoteTypes.Quote && !sendAnyway) {
          this.isConfirmModalActive = true
        } else {
          this.isConfirmModalActive = false
          this.sendQuoteType = type
          this.isOrmSendQuoteModalActive = true
        }
      })
    },
    async declineQuoteRequest() {
      if (this.$licenceExpired) return
      await this.saveAndContinue(async () => {
        this.isOrmDeclineQuoteRequestModalActive = true
      })
    },
    async sendInvoice(isReactivateInvoice) {
      if (this.$licenceExpired) return
      this.isReactivateInvoice = isReactivateInvoice
      const items = [...this.value.labours, ...this.value.others, ...this.value.parts, ...this.value.opgs, ...this.value.miscs, ...this.value.sublets]
      const itemsChanged = this.itemsChanged(items, this.value.quotingMethod)
      if (this.innerValue.quoteAssessments.some((a) => a.isInvoiced !== true)) {
        this.isWarningModalActive = true
      } else if (itemsChanged.length > 0 && this.innerValue.isAssessmentEnabled) {
        this.isWarningModalActive = true
      } else {
        await this.showSubmitTaxInvoiceModal()
      }
    },
    async getOrmUnreadPaymentAuthorisedMessage() {
      try {
        const messages = await OrmService.getMessages(this.innerValue.claimNo, this.innerValue.vehicleRego, MessageTypes.QML_PaymentAuthorised)

        if (!messages || messages.length === 0) {
          return
        }

        const latestMessage = [...messages].sort((a, b) => b.ormMessageNo - a.ormMessageNo)[0]
        this.ormLatestPaymentAuthorisedMessage = latestMessage
      } catch (error) {
        console.error('Error fetching ORM Payment Authorised messages:', error)
      }
    },
    async showSubmitTaxInvoiceModal() {
      if (this.ormUnreadMessageCount > 0) {
        this.$notification.openNotificationWithType('danger', 'ORM', 'There are unread ORM messages. Please load those messages before sending quote.')
        return
      }

      this.isWarningModalActive = false
      const hasPenndingMessage = await OrmMessageService.hasAnyPendingOrmMessage(this.innerValue.quoteId)
      if (hasPenndingMessage) {
        this.$notification.openNotificationWithType('danger', 'ORM', 'There are pending messages. Please load those messages before sending quote.')
        return
      }
      if (this.$parent && this.$parent.touchOrmHeaderValidators) {
        this.$parent.touchOrmHeaderValidators()
        this.$parent.touchOrmSummaryValidators()
      } else {
        this.touchOrmHeaderValidators()
        this.touchOrmSummaryValidators()
      }

      if (this.$parent && this.$parent.validateJobStartEndForOrm) {
        this.$parent.validateJobStartEndForOrm()
      } else {
        this.validateJobStartEndForOrm()
      }

      const hasJobDateError =
        !this.$v.entity.jobStart.bothRequired || !this.$v.entity.jobEnd.bothRequired || this.$v.entity.jobStart.$error || this.$v.entity.jobEnd.$error

      if (this.$v.ormHeaderGroup.$error || this.$v.ormSummaryGroup.$error || hasJobDateError) {
        this.$notification.openNotificationWithType('danger', 'ORM', 'Send cancelled. Required fields are missing or invalid')
        return
      }

      if (this.$parent && this.$parent.resetOrmValidation) {
        this.$parent.resetOrmValidation()
      } else {
        this.resetOrmValidation()
      }

      await this.saveAndContinue(async () => {
        this.isOrmSubmitTaxInvoiceModalActive = true
      })
    },
    reload() {
      this.$eventHub.$emit(EventHubTypes.EntityReload)
      this.showSuccessToast('Tax invoice is being submitted')
    },
    onPageChange(pageIndex) {
      this.filter.pageIndex = pageIndex
    },
    sort(name, order) {},
    async getOrmQuoteStatusTypes() {
      this.quoteStatusTypes = await OrmService.getOrmQuoteStatusTypes()
    },
    showUtilities() {
      this.isOrmUtilitiesModalActive = true
    },
    async viewOrmBatchDetail() {
      this.$router.push({ path: `/ormbatching/batch/${this.ormQuoteBatch.batchId}` })
    },
    async getOrmQuoteBatch() {
      this.ormQuoteBatch = await OrmBatchingService.getOrmQuoteBatch(this.innerValue.orm.quoteId)
    },
    async refreshInvoice() {
      this.updateInvoice()
    }
  }
}
</script>

<style lang="scss" scoped>
a.dropdown-item-has-icon {
  display: flex;
  align-items: center;
}
span.dropdown-item-text {
  padding-left: 5px;
}

.unread-messages-section {
  border: 1px solid var(--border-color);
  padding: 20px;
}

.bulma-message-modal {
  border: 1px solid var(--border-color);
}

.bulma-message-modal-footer {
  padding: 0.75rem 1rem 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.message.is-light .message-header {
  background-color: var(--message-header-light-bg);
  color: var(--message-header-light-color);
}
.message.is-dark .message-header {
  background-color: var(--message-header-dark-bg);
  color: var(--message-header-dark-color);
}
.message.is-light .message-body {
  background-color: var(--message-body-light-bg);
  color: var(--message-body-light-color);
  border: 2px solid var(--message-header-light-bg);
}
.message.is-dark .message-body {
  background-color: var(--message-body-dark-bg);
  color: var(--message-body-dark-color);
  border: 2px solid var(--message-header-dark-bg);
}

.dropdown-item.is-disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}

.difference-row {
  background-color: var(--bulma-background) !important;
}
.message.is-light .authorised-row {
  background-color: var(--bulma-success-95);
}
.message.is-dark .authorised-row {
  background-color: var(--bulma-success-15);
}

a {
  &.is-disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
}
</style>

<style lang="scss">
.quote-orm-licence-expired {
  .dropdown-item.is-licence-disabled,
  td:has(> input:disabled),
  td:has(> .select > select:disabled) {
    position: relative;
    cursor: not-allowed;

    &:hover::before {
      content: 'Disabled, as your licence has expired';
      position: absolute;
      z-index: 30;
      padding: 0.4rem 0.8rem;
      border-radius: 4px;
      background: rgba(74, 74, 74, 0.9);
      color: #fff;
      font-size: 0.75rem;
      font-weight: normal;
      white-space: nowrap;
      pointer-events: none;
    }
  }

  .dropdown-item.is-licence-disabled {
    > .icon,
    > .dropdown-item-text {
      opacity: 0.5;
    }

    &:hover::before {
      top: 50%;
      right: 100%;
      transform: translate(-0.5rem, -50%);
    }
  }

  td:has(> input:disabled),
  td:has(> .select > select:disabled) {
    &:hover::before {
      top: 100%;
      left: 0;
    }
  }

  td > input:disabled,
  td > .select > select:disabled {
    cursor: not-allowed;
  }
}
</style>

<style scoped>
.tr-top-border-2px {
  border-top: 2px var(--bulma-table-cell-border-style) var(--bulma-table-cell-border-color) !important;
}
</style>
